export const environment = {
    production: false,
    tracking_url: 'https://tracking-api.development.cafler.com/api',
    identity_url: 'https://api.development.cafler.com/dev/identity',
    products_url: 'https://products-api.development.cafler.com',
    copec_data_url: 'https://api.development.cafler.com/dev/copec',
    marketplace_url: 'https://api.development.cafler.com/dev',
    cafler_vehicles_url: 'https://api.development.cafler.com/dev/identity/fleet-vehicles',
    copec_api_version: 'v1',
    copec_access_key: 'f98c64762b28494a87620800e52115a4',
    identity_europe_url: 'https://func-europe-identity-development.azurewebsites.net/api',
    cafler_backoffice_back_url: 'https://wapi-dev-cafler-workshopmanager-hhekfecpbfg5e6f2.francecentral-01.azurewebsites.net/api',
    base: 'fleet-manager/',
    requested_page: '1',
    azureActiveDirectory: {
        clientId: '055e7106-8133-4621-b734-a7b88ea309bc',
        instance: 'https://identity.cafler.com/tfp/',
        tenant: '38e0a06f-5e98-4f79-b789-9ac3f3c7638b/',
        authority:
            'https://identity.cafler.com/tfp/38e0a06f-5e98-4f79-b789-9ac3f3c7638b/B2C_1_FleetManager_Development_PasswordReset/',
        policyName: 'B2C_1_FleetsLogin/',
        redirectUri: 'https://workshop.development.cafler.com/',
        postLogoutRedirectUri: 'https://workshop.development.cafler.com/'
    },
    BASE_URL: 'https://inbox.fonia.ai',
    API_VERSION: '/api/v1',
    ACCOUNT_ID: '29',
    TOKEN: '9FUocCVaS91obqBXw9P97aQ3',
    WIDGET_BASE_URL: 'https://cafler-agenda.azurewebsites.net',
    WIDGET_SCRIPT_PATH: '/booking/embed.js',
    redeemMinBalance: 3,
    featureFlags: {
        fintech: false,
    },
    sentry: {
        dsn: 'https://d698d44b63e7fcb57af9670370c96102@o970615.ingest.us.sentry.io/4510906249314304',
        environment: 'cafler-dev',
        sendDefaultPii: false,
        tracesSampleRate: 0.1,
        replaySampleRate: 0.0,
        replayOnErrorSampleRate: 0.1,
        enabled: true,
        release: '',
        enableLogs: true
    }
};
